<template>
    <div>
        <div class="showMoreButton" @click="isDisplayingMetadata = !isDisplayingMetadata">
            <i :class="showMetadataIcon"></i> {{$t(showMetadataText)}}
        </div>
        <div v-show="isDisplayingMetadata" style="margin-top:10px; margin-left:20px">
            <div>
                <b>{{$t('label_evaluation_overview_auditModelName')}}:</b>
                    {{evaluationData.modelName}}
            </div>
            <div>
                <b>{{$t('label_evaluation_overview_auditModelName_version')}}:</b>
                    {{evaluationData.modelVersion}}
            </div>
            <div>
                <b>{{$t('label_evaluation_administrator_evaluation_assignedResposible')}}:</b>
                  <span :key="respIndex" v-for="(responsible, respIndex) in evaluationData.evaluation_administrator_evaluations_assignedResposible">
                      <span v-if="respIndex > 0">, </span>
                      {{ responsible.name }} {{ responsible.lastName }}
                  </span>
            </div>
            <div>
                <b>{{$t('label_evaluation_administrator_evaluations_evaluationTarget')}}:</b>
                    {{evaluationData.evaluation_administrator_evaluations_evaluationTarget}}
            </div>
            <div>
                <b>{{$t('label_evaluation_administrator_evaluations_auditType')}}:</b>
                    {{$t(evaluationData.evaluation_administrator_evaluations_auditType)}}
            </div>
            <div v-if="organizations.length > 0">
                <b>{{$t('label_evaluation_overview_organizationsInfo')}}:</b>
                  <ul>
                    <li :key="organizationIndex" v-for="(organization, organizationIndex) in organizations">
                      <div>{{$t('label_evaluation_overview_organizationName')}}: {{organization.selfAssessment_general_business_companyName}}</div> 
                      <div>{{$t('label_evaluation_overview_snapshot')}}: {{organization.date}}</div>
                    </li>
                  </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "EvaluationModelHeaderMetadata",
  props: {
    evaluationData: {
      type: Object,
      default: () => {},
    },
    organizations: {
      type: Array,
      default: () =>[],
    },
  },
  
  data: function () {
    return {
      isDisplayingMetadata: false
    };
  },
  
  computed: {
    showMetadataText(){
      return !this.isDisplayingMetadata ? 'label_evaluation_show_more' : 'label_evaluation_show_less'
    },
    showMetadataIcon(){
      return !this.isDisplayingMetadata ? 'bi bi-chevron-down' : 'bi bi-chevron-up'
    },
  }
};
</script>

<style lang="sass" scoped>
@import "../../../../assets/css/variables"
.showMoreButton 
  margin-top:10px
  background: none!important
  border: none
  padding: 0!important
  color: $primary-color
  text-decoration: underline
  cursor: pointer

</style>